import React from 'react'
import Select from 'react-select'
import { managerSelectStyles } from 'tabs/dashboard/components/FilterDropdown.styles'

export const archiveStatusOptions = [
  { label: 'All Users', value: '' },
  { label: 'Active', value: 'UNARCHIVED' },
  { label: 'Archived', value: 'ARCHIVED' },
]

const ArchiveStatusFilter: React.FC<{ value: string; onChange: (value: string) => void }> = ({ value, onChange }) => (
  <div style={{ minWidth: 200 }}>
    <Select
      styles={managerSelectStyles}
      options={archiveStatusOptions}
      value={archiveStatusOptions.find(option => option.value === value) || archiveStatusOptions[0]}
      onChange={option => onChange(option?.value || '')}
      isSearchable={false}
      classNamePrefix="archive-status-select"
    />
  </div>
)

export default ArchiveStatusFilter
